module.exports = __webpack_public_path__ + "src/assets/img/truck2.da366092.png";